import pictures from '../../assests/assestimport.js';
const {mp} = pictures;

const masks=[
    {
        id:1,
        label:'3M 8210',
        band:"3M",
        description:`3M™ PARTICULATE RESPIRATOR-N95
        FEATURES : Cup Shaped Design With Welded Strap Attachment, For Non-Oil Based Particles, 
        Cushioning Nose Foam And Adjustable Nose Clip Helps Provide a Custom Fit and Secure Seal, 
        Lightweight Construction, Advanced Electret Media.`,
        image:mp[0],
        alt:"3M 8210 Particulate Respirator-N95 face mask",
        hscode:'63079099',
    },
    {
        id:2,
        label:'3M 8210V',
        band:"3M",
        description:`3M™ Particulate Respirator 8210V, N95
        Details
        Proprietary 3M™ Cool Flow™ Valve helps keeps wearer cool
        Cushioning nose foam
        Adjustable noseclip helps provide a custom and secure seal
        Advanced electrostatic media is designed for ease of breathing
        Compatible with a variety of protective eyewear and hearing protection`,
        image:mp[1],
        alt:"3M 8210V Particulate Respirator 8210V N95 face mask",
        hscode:'63079099',
    },
    {
        id:3,
        label:'3M 9010',
        band:"3M",
        description:`3M™ PARTICULATE RESPIRATOR-N95
        FEATURES : Vertical Flat Fold Design, For Non-Oil Based Particles, Adjustable Nose Clip Helps 
        Provide a Custom Fit and Secure Seal, Lightweight Construction, Advanced Electret Media, Individual Packing`,
        image:mp[2],
        alt:"3M 9010 Particulate Respirator-N95 face mask",
        hscode:'63079099',
    },
    {
        id:4,
        label:'3M 8710',
        band:"3M",
        description:`3M Disposable Respirator 8710, P1
        Features
         P1 rated filter to AS/NZ 1716:2012
         Lightweight construction promotes greater comfort and
        contributes to increased wear time.
         The cupped shape, twin strap design and adjustable
        aluminium nose clip provides a custom fit with fewer
        pressure points and a secure face seal over a range of face sizes
        Kraton headband for comfort and durability
        For use against both mechanically generated particulates e.g. dusts, mists
        All filter design provides economical protection with no cleaning required or spare parts to maintain
        Specifications
        Weight: 10g per respirator., Meets performance requirements of AS/NZ 1716:2012.
        Applications
        Mining, Woodwork, Sawmills, Construction, Grain Handling`,
        image:mp[3],
        alt:"3M 8710 Disposable Respirator P1 face mask",
        hscode:'63079099',
    },
    {
        id:5,
        label:'3M 8511',
        band:"3M",
        description:`3M™ PARTICULATE RESPIRATOR-N95
        FEATURES : Cup Shaped Design, Ideally Suited For Hot/Dusty Work Settings That Require Long Periods of Wear, 
        3M™ Cool Flow™ Exhalation Valve Reduces Heat Build-up Inside The Respirator, Braided Headbands, Spacious And 
        Durable, Designed To Increase Comfort And Wearability, Advanced Electret Media-Designed For Ease of Breathing, 
        For Non-Oil Based Particles, Adjustable Noseclip Helps Provide a Custom Fit and Secure Seal.`,
        image:mp[4],
        alt:"3M 8511 Particulate Respirator-N95 face mask",
        hscode:'63079099',
    },
    {
        id:6,
        label:'3M 8822',
        band:"3M",
        description:`3M™ PARTICULATE RESPIRATOR-FFP2
        FEATURES : Effective Respiratory Protection Against Dust And Mist, Convex Shape, Twin Strap Design, 
        Soft Nose Foam Adjustable Nose Clip, Durable, Collapse Resistant Inner Shell, 3M™ Cool Flow™ Exhalation Valve, 
        Lightweight, Comfortable.`,
        image:mp[5],
        alt:"3M 8822 Particulate Respirator-FFP2face mask",
        hscode:'63079099',   
    },
    {
        id:7,
        label:'3M 9332+',
        band:"3M",
        description:`3M™ Aura™ PARTICULATE RESPIRATOR-FFP3
        FEATURES : Low Breathing Resistance Filter Technology, Ingenious 3-Panel Design That Accommodates Greater 
        Facial Movement, Embossed Top Panel, Innovative Chin Tab For Ease Of Donning And Adjustment, With 3M™ Cool 
        Flow™ Exhalation Valve, Sculpted Nose Panel, Individual Packaging, Flat Fold Design, Protects Against Dusts 
        and Mists.`,
        image:mp[6],
        alt:"3M 9332+ Aura Particulate Respirator-FFP3 face mask",
        hscode:'63079099',   
    },
    {
        id:8,
        label:'3M 9320+',
        band:"3M",
        description:`3M™ Aura™ PARTICULATE RESPIRATOR-FFP2
        FEATURES : Low Breathing Resistance Filter Technology, Ingenious 3-Panel Design That Accommodates Greater 
        Facial Movement, Embossed Top Panel, Innovative Chin Tab For Ease Of Donning And Adjustment, With 3M™ Cool 
        Flow™ Exhalation Valve, Sculpted Nose Panel, Individual Packaging, Flat Fold Design, Protects Against Dusts 
        and Mists.`,
        image:mp[7],
        alt:"3M 9320+ Aura Particulate Respirator-FFP2 face mask",
        hscode:'63079099',   
    },
    {
        id:9,
        label:'N95',
        band:"Karem",
        description:`Disposable Face Mask 
        Wide cover rage of Face.
        Allow up to 20% more volume than 
       other mask. 
        Non-woven Polypropylene soft Fabric 
       design.`,
        image:mp[8],
        alt:"Karem N95 face mask",
        hscode:'',   
    },
    {
        id:10,
        label:'Disposable Face Mask Without Filter FFP2',
        band:"Karem",
        description:`Wide coverage over the face. Allows up to 20% more volume than other masks to relieve the user 
        from any feeling of claustrophobia.Minimizes breathing difficulties and speaking 
        discomfort. Comes with a catchy zigzag pattern on the edge`,
        image:mp[9],
        alt:"Karem Disposable Face Mask Without Filter FFP2 face mask",
        hscode:'',   
    },
    {
        id:11,
        label:'FFP2+',
        band:"Karem",
        description:`Wide coverage over the face. Allows up to 20% more volume than other masks to relieve the user 
        from any feeling of claustrophobia. Minimizes breathing difficulties and speaking discomfort. Comes with a 
        catchy zigzag pattern on the edge`,
        image:mp[10],
        alt:"Karem FFP2+ mask",
        hscode:'',   
    },
    {
        id:12,
        label:'Disposable Face Mask FFP1',
        band:"Karem",
        description:`Wide coverage over the face. Avaliable in white and grey colors`,
        image:mp[11],
        alt:"Karem Disposable Face Mask FFP1 face mask",
        hscode:'',   
    },
    {
        id:13,
        label:'3M 8247',
        band:"3M",
        description:`3M™ Particulate Respirator 8247, R95, with Nuisance Level OrganicThe lightweight, disposable R95 
        particulate respirator is constructed with carbon filter material for applications such as foundry operations, 
        lab settings, agriculture, petrochemical manufacturing and undercoating where particles and nuisance levels of 
        organic vapors may be present.`,
        image:mp[12],
        alt:"3M 8247 Particulate Respirator R95 face mask",
        hscode:'63079099',   
    },
    {
        id:14,
        label:'3M2091',
        band:"3M",
        description:`3M™ PARTICULATE FILTER-P100
        FEATURES : For Environments Containing Certain Oil And Non-Oil Based Particles, To Be Used With 3M™ Half And Full 
        FacePiece 6000 And 7000  Series With Bayonet Filter Holders.
        APPLICATIONS : Welding, Brazing, Torch Cutting, Metal Pouring, Soldering, Exposure To Lead, Asbestos, Cadmium, 
        Arsenic And MDA.`,
        image:mp[13],
        alt:"3M 2091 Particulate Filter-P100 of face mask",
        hscode:'63079099',   
    },
    {
        id:15,
        label:'3M 2097',
        band:"3M",
        description:`3M™ PARTICULATE FILTER-P100
        FEATURES : For Environments Containing Certain Oil And Non-Oil Based Particles, Recommended For Nuisance level 
        organic vapor relief and for ozone protection up to 10X OSHA PEL. To Be Used With 3M™ Half And Full 
        FacePiece 6000 And 7000  Series With Bayonet Filter Holders.
        APPLICATIONS : Welding, Brazing, Torch Cutting, Metal Pouring, Soldering, Exposure To Lead, Asbestos, 
        Cadmium, Arsenic And MDA.`,
        image:mp[14],
        alt:"3M 2097 Particulate Filter-P100 of face mask",
        hscode:'63079099',   
    },
    {
        id:16,
        label:'3M 6800 MEDIUM',
        band:"3M",
        description:`3M™ REUSABLE FULL FACE MASK RESPIRATOR
        FEATURES : Provides Filtering Protection Against Particulates, Gases And Vapours Present In Many Industrial 
        Applications, Bayonet Connection Fitting System To a Broad Range Of Filters, Soft, Non-Allergenic Elastomeric 
        Facepeice, Extremely Lightweight For High Comfort, Full Face Lens With Broad Field Of Vision, Scratch Resistant, 
        Well Balanced Four Strap Head Suspension Which Is Easy To Put On And Off.`,
        image:mp[15],
        alt:`3M 6800 MEDIUM Reusable Full Face Mask Respirator face mask Applications, Bayonet Connection Fitting System To a Broad Range Of Filters, Soft, Non-Allergenic Elastomeric 
        Facepeice, Extremely Lightweight For High Comfort, Full Face Lens With Broad Field Of Vision, Scratch Resistant, 
        Well Balanced Four Strap Head Suspension Which Is Easy To Put On And Off.`,
        hscode:'63079099',   
    },
    {
        id:17,
        label:'3M 6200 MEDIUM',
        band:"3M",
        description:`3M™ REUSABLE HALF FACE MASK RESPIRATOR
        FEATURES : Head Harness Cradle Suspension For Comfortable Fit, Lightweight Elastomeric Material For Comfort 
        During Long Periods Of Work, Low Profile Design For Maximum Field Of View, Twin Filter Design Provides Lower 
        Breathing Resistance, Bayonet Connection Fitting System To a Broad Range Of Filters To Protect Against Gases, 
        Vapours And Particulates, Economical, Low-Maintenance, Extremely Lightweight.`,
        image:mp[16],
        alt:"3M 6200 MEDIUM Reusable Half Face Mask Respirator face mask",
        hscode:'63079099',   
    },
    {
        id:18,
        label:'3M 6300 LARGE',
        band:"3M",
        description:`183M™ REUSABLE HALF FACE MASK RESPIRATOR
        FEATURES : Head Harness Cradle Suspension For Comfortable Fit, Lightweight Elastomeric Material For Comfort 
        During Long Periods Of Work, Low Profile Design For Maximum Field Of View, Twin Filter Design Provides Lower 
        Breathing Resistance, Bayonet Connection Fitting System To a Broad Range Of Filters To Protect Against Gases, 
        Vapours And Particulates, Economical, Low-Maintenance, Extremely Lightweight.`,
        image:mp[17],
        alt:"3M 6300 LARGE Reusable Half Face Mask Respirator face mask",
        hscode:'63079099',   
    },
    {
        id:19,
        label:'3M 6502 MEDIUM',
        band:"3M",
        description:`3M™ Reusable Half Face Mask Respirator, Medium, 6502
        Stay productive and protected – this half mask respirator delivers comfort, durability and stability with a firm, lightly textured silicone faceseal and strong body construction.
        Silicone Faceseal - Provides comfort and stability with a soft but firm faceseal. Extended product life due to resilient silicone material. Keeps it shape in high-heat environments. Lightweight.
        Adjustable Head Harness Assembly - Optimum fit and comfort with three-size adjustable head cradle. Durable harness straps.
        3M™ Bayonet Connection - Flexible bayonet system for connecion to a wide range of 3M™ gas, vapour particulate filters.
        3M™ Cool Flow™ Exhalation Valve - Enhanced comfort by reducing heat and moisture. Less exhalation resistance makes breathing easier.`,
        image:mp[18],
        alt:"3M 6502 MEDIUM Reusable Half Face Mask Respirator face mask",
        hscode:'84213990',   
    },
    {
        id:20,
        label:'3M 7502 MEDIUM',
        band:"3M",
        description:`3M™ REUSABLE HALF FACE MASK RESPIRATOR
        FEATURES : Advanced Silicone Material To Help Provide Comfortable And Durable Respiratory Protection, 
        The 3M™ Cool Flow™ Valve Helps Make Breathing Easier, Dual-Mode Head Harness For Standard Or Drop-Down 
        Mode, Solid Exhalation Valve Cover Which Directs Exhaled Breath And Moisture Downward While Helping Protect 
        The Valve Area From Debris While Also Making For Easier Cleaning.`,
        image:mp[19],
        alt:"3M 7502 MEDIUM Reusable Half Face Mask Respirator face mask",
        hscode:'63079099',   
    },
    {
        id:21,
        label:'3M 7503 LARGE',
        band:"3M",
        description:`3M™ REUSABLE HALF FACE MASK RESPIRATOR
        FEATURES : Advanced Silicone Material To Help Provide Comfortable And Durable Respiratory Protection, 
        The 3M™ Cool Flow™ Valve Helps Make Breathing Easier, Dual-Mode Head Harness For Standard Or Drop-Down 
        Mode, Solid Exhalation Valve Cover Which Directs Exhaled Breath And Moisture Downward While Helping Protect 
        The Valve Area From Debris While Also Making For Easier Cleaning.`,
        image:mp[20],
        alt:"3M 7503 LARGE Reusable Half Face Mask Respirator face mask",
        hscode:'63079099',   
    },
    {
        id:22,
        label:'3M 6001',
        band:"3M",
        description:`3M™ ORGANIC VAPOR CARTRIDGE
        FEATURES : NIOSH Approved Against Certain Organic Vapors, Use With 3M™ Half and Full FacePiece 6000, 7000 And 
        FF-400 Series With Bayonet Filter Holders, Swept-Back Design For Enhanced Field Of View And Balance.`,
        image:mp[21],
        alt:"3M 6001 Organic Vapor Cartridge face mask filter holder",
        hscode:'90200000',   
    },
    {
        id:23,
        label:'3M 6003',
        band:"3M",
        description:`3M™ ORGANIC VAPOR/ACID GAS CARTRIDGE
        FEATURES : Provides Respiratory Protection Against Certain Organic Vapors or Acid Gases, Use With 3M™ Half 
        and Full FacePiece 6000, 7000 And FF-400 Series With Bayonet Filter Holders, Swept-Back Design For Enhanced 
        Field Of View And Balance.`,
        image:mp[22],
        alt:"3M 6003 Organic Vapor/Acid Gas Cartridge face mask filter holder",
        hscode:'90200000',   
    },
    {
        id:24,
        label:'3M 6006',
        band:"3M",
        description:`3M™ UNIVERSAL GAS AND VAPOUR CARTRIDGE
        FEATURES :NIOSH Approved Against Certain Organic Vapors, Acid Gases, Ammonia, Methylamine or Formaldehyde, 
        Use With 3M™ Half and Full FacePiece 6000, 7000 And FF-400 Series With Bayonet Filter Holders, Swept-Back 
        Design For Enhanced Field Of View And Balance.`,
        image:mp[23],
        alt:"3M 6006 Universal Gas and Vapour Cartridge face mask filter holder",
        hscode:'90200000',   
    },
    {
        id:25,
        label:'3M 5N11',
        band:"3M",
        description:`3M™ PARTICULATE PREFILTER
        FEATURES : N95 NIOSH Approved Particulate Prefilter Pad For Certain Non Oil Based Particles,
        HEIGHT 3.4 Inch & Length 4.2 Inch
        3M 501 Must Required To Hold This Prefilter With 6000 Series Cartridge.`,
        image:mp[24],
        alt:"3M 5N11 Particulate Prefilter face mask filter holder",
        hscode:'63079099',   
    },
    {
        id:26,
        label:'3M 501',
        band:"3M",
        description:`3M™ FILTER RETAINER
        Retainer Used To Hold Particulate Filter 5N11`,
        image:mp[25],
        alt:"3M 501 Filter Retainer of face mask",
        hscode:'6307 9097',
    },
    {
        id:27,
        label:'V-410 SLV',
        band:"VENUS",
        description:`VENUS V-410 SLV FFP1 NR D CE approved flat fold style disposable respirator, buttery fly exhalation 
        vent valve for more breathing comfort in hot & humid conditions. Stapled textile elastic headbands does not deform 
        with repeat wears in hot environment. A unique adjuster bead provides optimum fitting to avoid leakage.`,
        image:mp[26],
        alt:"VENUS V-410 SLV FFP1 NR D CE approved flat fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:28,
        label:'V-420 SL',
        band:"VENUS",
        description:`VENUS V-420 SL FFP2 NR D CE approved flat fold style disposable respirator. Textile elastic 
        headbands does not deform with repeat wears in hot environment. A unique adjuster bead provides optimum 
        fitting to avoid leakage.`,
        image:mp[27],
        alt:"VENUS V-420 SL FFP2 NR D CE approved flat fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:29,
        label:'V-420 SLV',
        band:"VENUS",
        description:`VENUS V-420 SLV FFP2 NR D CE approved flat fold style disposable respirator  with buttery fly 
        exhalation vent valve for more breathing comfort in hot & humid conditions. Textile elastic headbands does 
        not deform with repeat wears in hot environment. A unique adjuster bead provides optimum fitting to avoid leakage.`,
        image:mp[28],
        alt:"VENUS V-420 SLV FFP2 NR D CE approved flat fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:30,
        label:'V-430 SLV',
        band:"VENUS",
        description:`VENUS V-430 SLV FFP3 NR D CE approved flat fold style disposable respirator with Buttery fly 
        exhalation vent valve for more breathing comfort in hot & humid conditions. Sewn Textile elastic headbands 
        does not deform with repeat wears in hot environment. A unique adjuster bead provides optimum fitting to avoid 
        leakage. Full foam seal improves fitting`,
        image:mp[29],
        alt:"VENUS V-430 SLV FFP3 NR D CE approved flat fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:31,
        label:'V-414',
        band:"VENUS",
        description:`VENUS V-414 FFP 2 NR D SLOV-V  CE approved flat fold style disposable respirator with Activated 
        Carbon to protect from nuisance level of odor. Transparent Buttery fly exhalation vent valve for more breathing 
        comfort in hot & humid conditions. Sewn Textile elastic headbands does not deform with repeat wears in hot 
        environment. A unique adjuster bead provides optimum fitting to avoid leakage. 
        Application: Chemical handling/Painting`,
        image:mp[30],
        alt:"VENUS V-414 FFP 2 NR D SLOV-V CE approved flat fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:32,
        label:'V-425 SLOV-V ',
        band:"VENUS",
        description:`VENUS V-425 SLOV-V FFP2 NR D CE approved flat fold style respirator with Activated Carbon to 
        protect from nuisance level of odor, welding application & Flame Retardant outer layer.  Transparent Buttery 
        fly exhalation vent valve for more breathing comfort in hot & humid conditions. Sewn Textile elastic headbands 
        does not deform with repeat wears in hot environment. A unique adjuster bead provides optimum fitting to avoid 
        leakage. Application: Welding`,
        image:mp[31],
        alt:"VENUS V-425 SLOV-V FFP2 NR D CE approved flat fold style respirator face mask",
        hscode:'',   
    },
    {
        id:33,
        label:'V-220 SL',
        band:"VENUS",
        description:`VENUS V-220 SL FFP2 NR D CE approved cup style disposable respirator. Textile elastic headbands 
        does not deform with repeat wears in hot environment. A unique adjuster bead provides optimum fitting to avoid 
        leakage.`,
        image:mp[32],
        alt:"VENUS V-220 SL FFP2 NR D CE approved cup style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:34,
        label:'V-220 SLV',
        band:"VENUS",
        description:`VENUS V-220 SLV FFP2 NR D CE approved cup style disposable respirator. Butterfly exhalation vent 
        valve provides more breathing comfort in hot & humid conditions. Textile elastic headbands does not deform with 
        repeat wears in hot environment. A unique adjuster bead provides optimum fitting to avoid leakage`,
        image:mp[33],
        alt:"VENUS V-220 SLV FFP2 NR D CE approved cup style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:35,
        label:'V-2430 SLV',
        band:"VENUS",
        description:`VENUS V-2430 SLV FFP3 NR D CE approved cup style disposable respirator. Butterfly exhalation vent 
        valve provides more breathing comfort in hot & humid conditions. Textile elastic headbands does not deform with 
        repeat wears in hot environment. A unique adjuster bead provides optimum fitting to avoid leakage`,
        image:mp[34],
        alt:"VENUS V-2430 SLV FFP3 NR D CE approved cup style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:36,
        label:'V-230 SLV',
        band:"VENUS",
        description:`VENUS V-230 SLV FFP3 NR D CE approved convex style disposable respirator with Buttery fly exhalation 
        vent valve for more breathing comfort in hot & humid conditions. Welded Textile elastic headbands does not deform 
        with repeat wears in hot environment. Front Adjuster broad cotton elastic gives fit and relives strap pressure. 
        Full foam seal improves fitting.`,
        image:mp[35],
        alt:"VENUS V-230 SLV FFP3 NR D CE approved convex style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:37,
        label:'V-2735 SLOV-V',
        band:"VENUS",
        description:`VENUS V-2735 SLOV-V FFP3 NR D CE approved Premium convex style respirator with Activated Carbon to 
        protect from nuisance level of odor, welding application & Flame Retardant outer layer. Buttery fly exhalation 
        vent valve for more breathing comfort in hot & humid conditions. Welded textile elastic headbands does not 
        deform with repeat wears in hot environment. Full foam seal improves fitting. A unique adjuster bead provides 
        optimum fitting to avoid leakage.  Application: Welding`,
        image:mp[36],
        alt:"VENUS V-2735 SLOV-V FFP3 NR D CE approved Premium convex style respirator face mask",
        hscode:'',   
    },
    {
        id:38,
        label:'4400 (N95)',
        band:"VENUS",
        description:`VENUS 4400 (N95) NIOSH Approved Flat Fold style disposable respirator. Welded textile elastic 
        headbands does not deform with repeat wears. A unique adjuster bead provides optimum fitting to  avoid leakage`,
        image:mp[37],
        alt:"VENUS 4400 (N95) NIOSH Approved Flat Fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:39,
        label:'4400 SN95',
        band:"VENUS",
        description:`VENUS 4400 SN95 (N95) NIOSH & FDA Approved Flat Fold style disposable respirator. Textile elastic 
        headbands does not deform with repeat wears. A unique adjuster bead provides optimum fitting to avoid leakage.`,
        image:mp[38],
        alt:"VENUS 4400 SN95 (N95) NIOSH & FDA Approved Flat Fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:40,
        label:'4200 (N95)',
        band:"VENUS",
        description:`VENUS 4200 (N95) NIOSH Approved Flat Fold style disposable respirator. Butterfly exhalation vent 
        valve provides more breathing comfort in hot & humid conditions. Welded textile elastic headbands does not deform 
        with repeat wears. Half foam seal improves wearer comfort. A unique adjuster bead provides optimum fitting to 
        avoid leakage.`,
        image:mp[39],
        alt:"VENUS 4200 (N95) NIOSH Approved Flat Fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:41,
        label:'CN95+ (N95)',
        band:"VENUS",
        description:`VENUS CN95+ (N95) NIOSH approved convex style disposable respirator, with Stapled rubber headbands. 
        Protection against solid dust and non-oil based liquid mist.`,
        image:mp[40],
        alt:"VENUS CN95+ (N95) NIOSH approved convex style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:42,
        label:'CVN95+ (N95)',
        band:"VENUS",
        description:`VENUS CVN95+ (N95) NIOSH approved convex style disposable respirator, butterfly exhalation vent valve 
        for more breathing comfort in hot & humid conditions.  Protection against solid dust and non-oil based liquid mist.`,
        image:mp[41],
        alt:"VENUS CVN95+ (N95) NIOSH approved convex style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:43,
        label:'RPD723 (N95)',
        band:"VENUS",
        description:`VENUS RPD723 (N95) NIOSH approved Beetle style disposable respirator.  Protection against solid dust 
        and non-oil based particles`,
        image:mp[42],
        alt:"VENUS RPD723 (N95) NIOSH approved Beetle style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:44,
        label:'V-4410 SL',
        band:"VENUS",
        description:`VENUS V-4410 SL FFP1 NR D CE approved flat fold style disposable respirator, textile elastic headband 
        does not deform with repeat wears in hot environment. Lint free sealing prevents contamination caused due to lose 
        fiber.`,
        image:mp[43],
        alt:"VENUS V-4410 SL FFP1 NR D CE approved flat fold style disposable respirator face mask",
        hscode:'',   
    },
    {
        id:45,
        label:'V-800',
        band:"VENUS",
        description:`Product Name:  VENUS V-800 Reusable Half Mask
        Size:  Medium Approval: EN 140 : 1998`,
        image:mp[44],
        alt:"VENUS V-800 Reusable Half Mask face mask",
        hscode:'',   
    },
    {
        id:46,
        label:'V-668',
        band:"VENUS",
        description:`Product: VENUS V-668 Full Face Mask 
        a. Dual Filter (DF) to be fitted with V-7800 filters
        b. Single Filter (SF) to be fitted with V-776 canisters `,
        image:mp[45],
        alt:"VENUS V-668 Full Face Mask face mask",
        hscode:'',   
    },
    {
        id:47,
        label:'V-9007900 ABEK1',
        band:"VENUS",
        description:`Product: VENUS V-9007900 ABEK1 Combo set`,
        image:mp[46],
        alt:"VENUS V-9007900 ABEK1 Combo face mask and filter set",
        hscode:'',   
    },
    {
        id:48,
        label:'V-7800 ABEK1P2SL',
        band:"VENUS",
        description:`Product Name:  VENUS V-7800 ABEK1P2SL to fit with V-800 Half Mask.
        Approval: EN 14387
        2Prs/Pack | 12Pack/Crtn`,
        image:mp[47],
        alt:"VENUS V-7800 ABEK1P2SL face mask filter holder",
        hscode:'',   
    },
]

export default masks;